// extracted by mini-css-extract-plugin
export default {"active":"GlossaryButton_active__bBWxH"};